import { render, staticRenderFns } from "./ExcursionView.vue?vue&type=template&id=74f34ce4&"
import script from "./ExcursionView.vue?vue&type=script&lang=js&"
export * from "./ExcursionView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports